import { V2GetProjectByIdApiResponse } from "@generated";

// The project's rate table id from a /v2/projects/:id response requested with
// include=rate-table. The included record is the fallback: the API can omit the
// rate-table linkage from `relationships` even when the rate table is included.
const projectRateTableId = (
  response: V2GetProjectByIdApiResponse | undefined
): string | undefined => {
  const id =
    response?.data?.relationships?.["rate-table"]?.data?.id ??
    response?.included?.find((i) => i.type === "rate-tables")?.id;
  return id != null ? String(id) : undefined;
};

export default projectRateTableId;
